<div class="ec-shell">
  <div class="container">

    <!-- HEADER -->
    <div class="ec-header">
      <div class="ec-title-block">
        <div class="icon-box">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 11 12 14 22 4"></polyline>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
          </svg>
        </div>
        <div class="title-text">
          <h1>Conferência de Estoque</h1>
          <p>Selecione um pedido para iniciar ou continuar a conferência.</p>
        </div>
      </div>

      <!-- Badge da empresa filtrada -->
      <div class="badge-empresa-tela" *ngIf="!legadoAberto"
           [style.background]="empresaState.corClaraPorCodEmp(empresaState.selecionada, 0.78)"
           [style.border-color]="empresaState.corPorCodEmp(empresaState.selecionada)">
        <span class="badge-empresa-dot" [style.background]="empresaState.corPorCodEmp(empresaState.selecionada)"></span>
        <span class="badge-empresa-texto">
          Empresa {{ empresaState.selecionada }}<ng-container *ngIf="nomeEmpresaAtual"> — {{ nomeEmpresaAtual }}</ng-container>
        </span>
      </div>

      <!-- Quando a fonte é o Sistema Legado (Aerosys), a "empresa" relevante é a
           empresa do Aerosys sendo consultada -- seletor próprio, mesmo padrão
           do Aplicativo de Separação (ver estoque-separacao.component.html). -->
      <div class="badge-empresa-tela badge-empresa-legado" *ngIf="legadoAberto">
        <span class="badge-empresa-dot dot-legado"></span>
        <span class="badge-empresa-texto" *ngIf="legadoEmpresasCarregando"><app-loading-indicator size="inline"></app-loading-indicator> Carregando empresas...</span>
        <select
          *ngIf="!legadoEmpresasCarregando"
          class="sel-empresa-legado"
          [ngModel]="legadoEmpresaSelecionada?.id ?? null"
          (ngModelChange)="onLegadoEmpresaSelectChange($event)"
          title="Empresa do Sistema Legado (Aerosys)"
        >
          <option *ngIf="!legadoEmpresaSelecionada" [ngValue]="null" disabled>Selecione a empresa...</option>
          <option *ngFor="let emp of legadoEmpresas" [ngValue]="emp.id">
            {{ emp.nome || emp.razao || ('Empresa ' + emp.id) }}
          </option>
        </select>
      </div>

      <!-- Indicador (não clicável) de que este usuário vê o Sistema Legado nesta tela. -->
      <div *ngIf="podeVerVendasLegado" class="badge-fonte-legado" title="Esta tela mostra as vendas do Sistema Legado (Aerosys), não os pedidos do Sankhya">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <line x1="9" y1="9" x2="15" y2="9"></line>
          <line x1="9" y1="13" x2="15" y2="13"></line>
          <line x1="9" y1="17" x2="12" y2="17"></line>
        </svg>
        Sistema Legado
      </div>
    </div>

    <!-- Vendas do Sistema Legado (Aerosys): erros/estados da escolha de empresa. -->
    <div *ngIf="legadoAberto && legadoEmpresasErro" class="alert alert-danger">{{ legadoEmpresasErro }}</div>
    <div *ngIf="legadoAberto && legadoErro" class="alert alert-danger">{{ legadoErro }}</div>
    <div *ngIf="legadoAberto && legadoEmpresaSelecionada == null && !legadoEmpresasCarregando && legadoEmpresas.length === 0 && !legadoEmpresasErro" class="alert alert-danger">
      Nenhuma empresa do Sistema Legado disponível para este usuário.
    </div>

    <!-- ERRO INICIAR / FINALIZAR -->
    <div *ngIf="erroFinalizar" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroFinalizar }}
    </div>
    <div *ngIf="erroIniciar" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroIniciar }}
    </div>

    <!-- ERRO -->
    <div *ngIf="erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <!-- LISTAGEM -->
    <div class="content-card" *ngIf="!aguardandoEscolhaEmpresaLegado">
      <div *ngIf="carregandoLinhas" class="loading-state">
        <app-loading-indicator></app-loading-indicator>
        <span>{{ legadoAberto ? 'Buscando vendas do Sistema Legado...' : 'Buscando pedidos para conferência...' }}</span>
      </div>

      <div *ngIf="!carregandoLinhas && linhas.length === 0 && !erro" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
        <h3>Fila Limpa!</h3>
        <p>{{ legadoAberto ? 'Não há vendas aguardando conferência no Sistema Legado no momento.' : 'Não há nenhum pedido aguardando conferência no momento.' }}</p>
      </div>

      <div class="pedidos-grid" *ngIf="!carregandoLinhas && linhas.length > 0">
        <div class="pedido-card" *ngFor="let p of linhas" [class.pedido-card-legado]="p.origem === 'aerosys'">

          <div class="card-header" [class.card-header--pendencia]="p.retornouPendencia">
            <span class="nunota-badge">#{{ p.origem === 'aerosys' ? p.numTituloLegado : p.nunota }}</span>
            <div class="badges-right">
              <span class="badge badge-retorno-pendencia" *ngIf="p.retornouPendencia" title="Vendedor ajustou — pronto para finalizar">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                Ajustado!
              </span>
              <span class="badge badge-imediato" *ngIf="p.imediato === 'Sim'">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                Imediato
              </span>
              <span [ngClass]="prioridadeClass(p.prioridade)" [class.alta]="p.prioridade === 'Alta'">
                {{ p.prioridade || 'Normal' }}
              </span>
            </div>
          </div>

          <div class="card-body">
            <h3 class="cliente-nome">{{ p.nomeCliente }}</h3>

            <!-- Prefixo -->
            <p *ngIf="p.prefixo" class="card-info-row card-prefixo-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19.5 2.5S18 2 17 2l-3.5 3.5L5 4.2l-1.4 1.4 6.6 2.8-3 3-2.8-.7-1.4 1.4 4.6 2.4 2.4 4.6 1.4-1.4-.7-2.8 3-3z"></path></svg>
              <span class="card-info-label">Prefixo:</span>
              <span class="card-prefixo-badge">{{ p.prefixo }}</span>
            </p>

            <!-- TAG (definida na Separação) -->
            <p *ngIf="p.numTag" class="card-info-row card-tag-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
              <span class="card-info-label">TAG:</span>
              <span class="card-tag-badge">{{ p.numTag }}</span>
            </p>

            <!-- Vendedor -->
            <p class="card-info-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
              <span class="card-info-label">Vendedor:</span> {{ p.vendedor }}
            </p>

            <!-- Conferente + Data Início (só quando em conferência por mim) -->
            <p *ngIf="emConferencia(p)" class="card-info-row card-conf-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
              <span class="card-info-label">Conferente:</span>
              {{ p.confNome && p.confNome.trim() ? p.confNome : (p.confCodusu > 0 ? 'Conferente #' + p.confCodusu : 'Em conferência') }}
            </p>
            <p *ngIf="emConferencia(p) && p.dataInicio" class="card-info-row card-datainicio-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
              <span class="card-info-label">Início:</span> {{ p.dataInicio }}
            </p>

            <!-- Progresso (só quando em conferência por mim) -->
            <div *ngIf="emConferencia(p) && p.totalItens > 0" class="card-progresso">
              <div class="card-progresso-texto">
                <span>{{ p.qtdConferidos }} / {{ p.totalItens }} itens conferidos</span>
                <span class="card-progresso-pct">{{ p.totalItens > 0 ? ((p.qtdConferidos / p.totalItens) * 100 | number:'1.0-0') : 0 }}%</span>
              </div>
              <div class="card-progresso-bar">
                <div class="card-progresso-fill"
                     [style.width.%]="p.totalItens > 0 ? (p.qtdConferidos / p.totalItens) * 100 : 0">
                </div>
              </div>
            </div>

            <!-- Total itens (só SEPARACAO TOTAL / aguardando) -->
            <p *ngIf="!emConferencia(p)" class="card-info-row card-itens-row">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
              <span>{{ p.totalItens }} {{ p.totalItens === 1 ? 'item' : 'itens' }}</span>
            </p>
          </div>

          <!-- Banner: retornou da pendência do vendedor -->
          <div *ngIf="p.retornouPendencia" class="pendencia-retorno-banner">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
            <span>Vendedor ajustou os itens — você pode finalizar a conferência!</span>
          </div>

          <div class="card-footer">
            <!-- Retornou da pendência E todos conferidos → Finalizar direto -->
            <button *ngIf="podeFinalizarDireto(p)"
                class="btn-finalizar-direto"
                (click)="finalizarDiretamente(p)"
                [disabled]="finalizandoNunota === p.nunota">
              <svg *ngIf="finalizandoNunota !== p.nunota" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
              <span>{{ finalizandoNunota === p.nunota ? 'Finalizando...' : 'Finalizar Conferência' }}</span>
            </button>
            <!-- Em conferência por mim E não pode finalizar direto → Continuar (Sankhya) -->
            <button *ngIf="emConferencia(p) && !podeFinalizarDireto(p) && p.origem !== 'aerosys'"
                class="btn-continuar"
                (click)="iniciar.emit(p.nunota)">
              <span>Continuar Conferência</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- Sistema Legado -- sem validação de posse: "Continuar"/"Iniciar" são
                 sempre o mesmo botão/handler (ver continuarOuIniciarLegado). -->
            <button *ngIf="p.origem === 'aerosys'"
                type="button"
                class="btn-continuar"
                (click)="continuarOuIniciarLegado(p)">
              <span>{{ emConferencia(p) ? 'Continuar Conferência' : 'Iniciar Conferência' }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- Aguardando → Iniciar (Sankhya) -->
            <button *ngIf="!emConferencia(p) && p.origem !== 'aerosys'"
                class="btn-iniciar"
                (click)="iniciarConferencia(p)"
                [disabled]="iniciandoNunota === p.nunota">
              <span *ngIf="iniciandoNunota !== p.nunota">Iniciar Conferência</span>
              <span *ngIf="iniciandoNunota === p.nunota"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
              <svg *ngIf="iniciandoNunota !== p.nunota" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </button>
            <!-- Item pendente voltou do outro galpão -- sininho de aviso, mesmo
                 recurso da Separação (ver ITENS_PENDENCIA_RESOLVIDA em
                 ConferenciaComponent, GPL-Integracao backend). -->
            <button *ngIf="emConferencia(p) && (p.itensPendenciaResolvida ?? 0) > 0"
                type="button"
                class="btn-sininho-pendencia"
                title="Itens que voltaram do outro galpão -- clique para finalizar a conferência"
                (click)="p.origem === 'aerosys' ? continuarOuIniciarLegado(p) : iniciar.emit(p.nunota)">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
              <span class="sininho-badge">{{ p.itensPendenciaResolvida }}</span>
            </button>
            <!-- Estornar para SEPARACAO -- só fluxo nativo Sankhya (essa ação chama
                 o backend do Sankhya, que não sabe nada das vendas do Aerosys). -->
            <button type="button"
                *ngIf="p.origem !== 'aerosys'"
                class="btn-estornar"
                title="Estornar pedido para Separação"
                (click)="solicitarEstornar($event, p)"
                [disabled]="estornandoNunota === p.nunota">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
              <span>Estornar</span>
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- MODAL: Confirmar Estorno para SEPARACAO -->
  <div class="tag-modal-overlay" *ngIf="confirmandoEstorno" (click)="cancelarEstornar()">
    <div class="tag-modal-box" (click)="$event.stopPropagation()">
      <div class="tag-modal-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
        <span>Estornar Pedido para Separação</span>
      </div>

      <p class="tag-modal-subtitulo">
        Pedido <strong>#{{ confirmandoEstorno.nunota }}</strong> — {{ confirmandoEstorno.nomeCliente }}
      </p>

      <p class="tag-modal-aviso">
        O pedido voltará para a fila de Separação. O progresso de conferência e de separação já feitos neste pedido serão descartados — será preciso separar e conferir os itens novamente.
      </p>

      <div *ngIf="erroEstornar" class="tag-modal-erro">{{ erroEstornar }}</div>

      <div class="tag-modal-footer">
        <button type="button" class="tag-modal-btn-cancelar"
                (click)="cancelarEstornar()"
                [disabled]="estornandoNunota !== null">
          Cancelar
        </button>
        <button type="button" class="tag-modal-btn-confirmar tag-modal-btn-perigo"
                (click)="confirmarEstornar()"
                [disabled]="estornandoNunota !== null">
          <span *ngIf="estornandoNunota === null">Confirmar Estorno</span>
          <span *ngIf="estornandoNunota !== null"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
        </button>
      </div>
    </div>
  </div>
</div>
